import { IndexedDBService } from "../../../../services/indexed-db-service";

const clientNotesDB = new IndexedDBService("ClientNotes", "notes");

export const getNoteKey = (userId, noteId) => `${userId}_${noteId || "new"}`;

export const saveDraft = (key, content) => {
  if (!key || content === undefined) {
    return;
  }
  clientNotesDB.save(key, content);
};

export const getDraft = async (key) => {
  if (!key) {
    return "";
  }
  return await clientNotesDB.get(key);
};

export const deleteDraft = (key) => {
  if (!key) {
    return;
  }
  clientNotesDB.delete(key);
};
